import type { MutationHookOptions } from '@apollo/client'
import {
  UpsertPeopleChartHierarchyDocument,
  UpsertPeopleChartHierarchyMutation,
  UpsertPeopleChartHierarchyMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpsertPeopleChartHierarchyMutation,
  UpsertPeopleChartHierarchyMutationVariables
>

export const useUpsertHierarchy = (options?: Options) => {
  const [upsertHierarchy, { loading }] = useMutation(UpsertPeopleChartHierarchyDocument, {
    ...options,
    extractorFn: (data) => data.peopleChartMutations.upsertPeoplechartStructure,
  })

  return {
    loading,
    upsert: upsertHierarchy,
  }
}
